import { createContext, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    const token = localStorage.getItem("smj_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("smj_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("smj_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("smj_token");
    localStorage.removeItem("smj_admin_token");
    queryClient.clear();
    setUser(false);
  };

  const impersonate = async (token) => {
    const admin = localStorage.getItem("smj_token");
    if (admin) localStorage.setItem("smj_admin_token", admin);
    localStorage.setItem("smj_token", token);
    queryClient.clear();
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const stopImpersonating = async () => {
    const admin = localStorage.getItem("smj_admin_token");
    if (admin) {
      localStorage.setItem("smj_token", admin);
      localStorage.removeItem("smj_admin_token");
    }
    queryClient.clear();
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setUser, impersonate, stopImpersonating }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
